import { render, staticRenderFns } from "./MainTile.vue?vue&type=template&id=47023c04&"
import script from "./MainTile.vue?vue&type=script&lang=js&"
export * from "./MainTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports